import {Button, Dialog, Paper, Typography} from "@mui/material";

export type ImpressDialogProps = {
  open: boolean
  onClose: () => void
}

export const ImpressDialog = ({open, onClose}: ImpressDialogProps) => {
  return (
    <Dialog open={open} onClose={() => onClose()}>
      <Paper elevation={1} style={{padding: 25}} color="secondary">
        <h2>Impressum</h2>
        <Typography fontWeight="bold" fontSize={20}>Informationen für §5 TMG</Typography>
        <Typography fontSize={15}>
          Stefan Hoferer<br/>
          Schönberg 4<br/>
          84564 Oberbergkirchen
        </Typography>
        <Typography fontWeight="bold" fontSize={20} style={{marginTop: 10}}>Kontakt</Typography>
        <Typography fontSize={15}>
          Phone: (+49) 0162 339 0867<br/>
          E-Mail: stefan@fancynetwork.net
        </Typography>
        <Button
          style={{float: 'right', marginTop: 45, fontWeight: 'bold'}}
          color="primary"
          variant="contained"
          onClick={() => onClose()}>
          Schließen
        </Button>
      </Paper>
    </Dialog>
  )
}